export const getConditional = () => {
    // Gets the class based on the rules
    const getConditionalClass = (field, formData) => {
        if (!field || !field.enableConditions || !field.conditions || !formData) {
            return '';
        }

        const conditional = JSON.parse(field.conditions);
        const rules = conditional.conditions;
        const showRule = conditional.showRule;
        const conditionRule = conditional.conditionRule;

        if (!rules.length) {
            return '';
        }

        const rulesMatchList = getMatchedRules(rules, formData);
        return getClass(rulesMatchList, showRule, conditionRule) || '';
    };

    const skipConditionalRender = (field, formData) => [
        'Field_MultiLineText'
    ].includes(field.typeName) && (
        getConditionalClass(field, formData) === 'formie-field--hidden'
    );

    return {
        getConditionalClass,
        skipConditionalRender
    };
};

const getMatchedRules = (rules, formData) => {
    return rules.map((rule) => {
        const value = rule.value;

        // Rule.field is a string like {name} or {name.lastName}
        const strippedField = rule.field?.replace(/{|}/g, '');
        // Remove the prefix field: if it exists
        const cleanedField = strippedField.startsWith('field:') ? strippedField.replace('field:', '') : strippedField;
        // First the {} are removed, then the field is split by the dot, and the value is retrieved from the formData
        const fieldValue =
            cleanedField
                .split('.')
                .reduce((obj, prop) => obj[prop], formData);

        switch (rule.condition) {
        case '=':
            return fieldValue === value;
        case '!=':
            return fieldValue !== value;
        case '>':
            return fieldValue > value;
        case '<':
            return fieldValue < value;
        case 'contains':
            return fieldValue.includes(value);
        case 'startsWith':
            return fieldValue.startsWith(value);
        case 'endsWith':
            return fieldValue.endsWith(value);
        default:
            return false;
        }
    });
};

const getClass = (rulesResults, showRule, conditionRule) => {
    if (conditionRule === 'all') {
        if (showRule === 'show') {
            return rulesResults.every(rule => rule === true) ?
                'formie-field--visible' :
                'formie-field--hidden';
        }

        if (showRule === 'hide') {
            return rulesResults.every(rule => rule === true) ?
                'formie-field--hidden' :
                ''; // since fields are visible by default
        }
    }

    if (conditionRule === 'any') {
        if (showRule === 'show') {
            return rulesResults.includes(true) ?
                'formie-field--visible' :
                'formie-field--hidden';
        }

        if (showRule === 'hide') {
            return rulesResults.includes(true) ?
                'formie-field--hidden' :
                ''; // since fields are visible by default
        }
    }
};
